import { StepLink } from "@pages/onboarding/core/components/step-link";

import { type Platform } from "../constants";
import { getTitleForPlatform } from "../metadata";

export function UtmSpendAdditionalDetails(platform: Platform) {
  const title = getTitleForPlatform(platform);
  return [
    {
      title: `What does the ${title} UTM track?`,
      content: `Performance metrics are tracked with UTMs.
      Northbeam then maps performance from UTMs to spend pulled from the Spend API connection.`,
    },
    {
      title: `How is spend tracked for ${title}?`,
      content: (
        <>
          Spend is tracked through Northbeam’s Spend API. You’ll need to{" "}
          <StepLink step="spend-api">configure the Spend API</StepLink> in next
          step
        </>
      ),
    },
  ];
}
